import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface VideoState {
  timestamp?: number,
}

export const initialState = {} as VideoState;

const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    updateTimestamp(draft, action: PayloadAction<number>) {
      draft.timestamp = action.payload;
    },
  },
});

export const selectTimestamp = (store) => (
  store.apps.job.video.timestamp as number
);

export const { updateTimestamp } = videoSlice.actions;
export default videoSlice.reducer;
